import Vue from 'vue';

import { ssoAllaSidorMixin } from 'v-mixins/ssoAllaSidorMixin';

import euiFormTextruta from 'v-components/euiFormTextruta.vue';
import euiFormKryssruta from 'v-components/euiFormKryssruta.vue';

import objectToFormData from 'object-to-formdata';

import euiDialogClasses from 'v-components/classes/euiDialogClasses';
import euiDialog from 'v-components/euiDialog';

import { ValidationObserver } from 'vee-validate';

import VeeValidateInstanceMedRattOptions from 'VeeValidateInstanceMedRattOptions';
VeeValidateInstanceMedRattOptions.runOnce();		// Kör funktionen om den inte redan körts!


window.ssoLoggaIn = window.ssoLoggaIn || {};	// För att undvika ESLint-varningar att den är odefinierad.

//##############################################################################################################################


//console.time('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!
const app = new Vue({
	el: '._vue-app-body-container',

	// Lokalt registrerade komponenter
	components: {
		euiFormTextruta,
		euiFormKryssruta,
		'validation-observer': ValidationObserver,
		euiDialog,
	},

	// Gemensam funktionalitet, utseende, data etc för alla sidor, se 'v-sso-Alla-sidor-mixin.js'.
	mixins: [ssoAllaSidorMixin],

	// Data utöver de från mixin ovan:
	data: {
		// Reaktiva data:

		returnUrl: window.ssoLoggaIn.returnUrl,
		aterstallLosenDirekt: window.ssoLoggaIn.aterstallLosenDirekt,

		// Obs! Måste stämma med form model som används i controllern (i detta fall på prov *utan* krav på C# naming convention, se [JsonProperty(...)]-attribut i C#!):
		loggaInFormModel: window.ssoLoggaIn.loggaInFormModel,
		verifieraKodenFormModel: window.ssoLoggaIn.verifieraKodenFormModel,

		aterstallLosenDialogConfig: new euiDialogClasses.dialogConfig([
			new euiDialogClasses.knappAvbryt(),
			new euiDialogClasses.knappEvent('Begär återställning/ändring', 'aterstallLosen', { validateBeforeEmit: true }),
		]),

		verifieraKodenDialogConfig: new euiDialogClasses.dialogConfig([
			new euiDialogClasses.knappAvbryt(),
			new euiDialogClasses.knappEvent('Verifiera koden', 'verifieraKoden', { validateBeforeEmit: true }),
		]),


		// Obs! Nedan: inte reaktiva (read-only) data, medelst användningen av Object.freeze():

		// –
	},

	methods: {

		onLoggaIn()
		{
			// Validera först!
			this.$refs.validationsobserveraren.validate()
				.then((isValid) => {

					if (!isValid) {
						// Om formuläret inte validerar:
						// Då har feltexter visats i formuläret:
						// Bara aborta emittandet.
					}
					else
					{
						// Allt validerar *client-side* (*standard-valideringar*):

						const formData = objectToFormData(this.loggaInFormModel);

						this.AjaxpostaOchHanteraResultat('/konto/logga-in', {
							// formData = new FormData(),				// Tomma data
							// withoutSpinner = false,
							// doljSpinnerOnSuccess = false,			// Default = nej. Måste då vid behov döljas i onSuccessFunction(), men rekommenderas att man struntar i om sidnavigering också görs i den.
							// onFailureFunction = undefined,		// Om satt: *istället* för att visa felmeddelandet.
							// onCatchedErrorFunction = undefined,	// Om satt: *istället* för att visa ajax-felmeddelandet.
							// onSuccessFunction = undefined,

							formData: formData,
							doljSpinnerOnSuccess: false,	//! Hanteras manuellt vid success nedan, beroende på vad som...
							onSuccessFunction: (resultat) => {

								// Stäng av redigeraläget:
								this.arIRedigeralage = false;

								// // Här är CustomData en C# 'LoggaInOchSkickaKodenOchVerifieraKodenCustomData', med proparna:
								// // - ReturnUrl
								// // - KomIhagMig
								// // - TwoFactorRequired

								// Här är CustomData en SingleValueCustomData<bool> med innebörden 'twoFactorRequired':
								const twoFactorRequired = resultat.CustomData;

								//? TODO: Av någon anledning slår dessa i C# inte igenom till webbläsaren:
								//[JsonProperty(PropertyName = "returnUrl")]      // camelCase för js

								if (twoFactorRequired === true)
								{
									// Om twoFactorRequired, anropa server side för att mejla koden + visa sedan TwoFactor-dialogen:

									//! KVAR: TODO: Denna trassliga nästning av kod ska refactoras:

									// // I detta fall stoppar vi spinnern:
									// this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;

									this.AjaxpostaOchHanteraResultat('/konto/skicka-koden', {
										formData: formData,	//! Samma formData som i 1:a steget ovan.
										doljSpinnerOnSuccess: true,
										onSuccessFunction: (resultat) => {

											// // Stäng av redigeraläget:
											// this.arIRedigeralage = false;

											// // Här är CustomData en C# 'LoggaInOchSkickaKodenOchVerifieraKodenCustomData', med proparna:
											// // - returnUrl
											// // - twoFactorRequired
											// const customData = resultat.CustomData;

											// Prepa verifieraKodenFormData med rätt komIhagMig = samma som i loggaInFormModel:
											this.verifieraKodenFormModel.komIhagMig = this.loggaInFormModel.komIhagMig;

											// Visa TwoFactor-dialogen:
											this.verifieraKodenFormModel.sakerhetskodFor2FA = '';		// Töm koden (ifall dialogen öppnats tidigare)
											this.verifieraKodenDialogConfig.visas = true;
										},
									});
								}
								else
								{
									// Annars är inloggningen nu godkänd och klar:
									// Navigera till returnUrl, eller till startsidan om sådan saknas:

									// I detta fall stoppar vi inte spinnern = den fortsätter tills navigeringen genomförts:
									//this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;

									window.location.href = this.returnUrl || '/';		// null coalescing operator i js: https://stackoverflow.com/a/476445/593779
								}
							},
						});
					}
				});
		},

		onKnappTrycktIVerifieraKodenDialog({ eventId, eventData }) {
			switch (eventId) {
				case 'verifieraKoden':
					{
						// När man kommer hit: Allt validerar *client-side* (*standard-valideringar*):

						this.AjaxpostaOchHanteraResultat('/konto/verifiera-koden', {
							formData: objectToFormData(this.verifieraKodenFormModel),
							doljSpinnerOnSuccess: false,	//! Hanteras manuellt vid success nedan.
							onSuccessFunction: (resultat) => {

								// Nu är TwoFactor-inloggningen godkänd och klar:
								// Navigera till returnUrl, eller till startsidan om sådan saknas:

								// I detta fall stoppar vi inte spinnern = den fortsätter tills navigeringen genomförts:
								//this.sidanInaktiveradMedFullOpacitetOchSpinnerVisasEfterXs = false;

								window.location.href = this.returnUrl || '/';		// null coalescing operator i js: https://stackoverflow.com/a/476445/593779
							},
						});

						break;
					}
			}
		},

		onAterstallLosen()
		{
			this.aterstallLosenDialogConfig.visas = true;
		},

		onKnappTrycktIAterstallLosenDialog({ eventId, eventData }) {
			switch (eventId) {
				case 'aterstallLosen':
					{
						// När man kommer hit: Allt validerar *client-side* (*standard-valideringar*):

						this.AjaxpostaOchHanteraResultat('/konto/begar-aterstallning-losen', {
							formData: objectToFormData({ epost: this.loggaInFormModel.epost }),
							doljSpinnerOnSuccess: true,
							onSuccessFunction: (resultat) => {

								// Visa lyckatmeddelande:
								this.visaMeddelande(
									`
<p>Vi har nu skickat ett återställnings&shy;mejl till <b>${this.loggaInFormModel.epost}</b>.</p>
<p>Följ anvisningarna i mejlet för att återställa/ändra ditt lösen.</p>
									`,
									{ ikon: 'lyckatmeddelande', ikonCssModifierClass: '-lyckat' }
								);

								// Först nu ska dialogen stängas!
								this.aterstallLosenDialogConfig.visas = false;
							},
						});

						break;
					}
			}
		},
	},


	//== Lifecycle hooks  ================================================================================================================

	//created()
	//{
	//	// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.
	//},

	//mounted()
	//{
	//	// Programmatisk bind:
	//	this.$on('meddelandedialog-stangs', this.onMeddelandedialogStangs);
	//},

	mounted() {

		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			console.log('Med querystring som indikerar att återställning av lösenord ska initieras direkt');

			if (this.aterstallLosenDirekt === true)
				this.onAterstallLosen();
		});
	},
});
//console.timeEnd('#TIMING: Skapa Vue-appen');	// Todo: TEMP!!!


export default app;

// Sätter även en global variabel, för enkel åtkomst till Vue-instansen (motsvarande $root) från DevTools console, icke-modulariserad javascript etc:
window.App = app;
